var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C11.4477 23 11 22.5523 11 22V12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12V22C13 22.5523 12.5523 23 12 23Z",
    fill: "#515252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13C8.6863 13 6.00001 10.3137 6.00001 6.99998C5.99844 6.08052 6.21069 5.1733 6.62001 4.34998C6.88496 3.89808 7.45375 3.72724 7.92385 3.95835C8.39395 4.18947 8.60603 4.7442 8.41001 5.22998C7.61973 6.83155 7.98692 8.76297 9.30978 9.96281C10.6326 11.1627 12.5906 11.3402 14.1077 10.3978C15.6248 9.45544 16.3334 7.62155 15.844 5.90396C15.3546 4.18637 13.786 3.00128 12 2.99998C11.5797 3.00292 11.162 3.06693 10.76 3.18998C10.2354 3.36077 9.67153 3.07438 9.50001 2.54998C9.41842 2.2967 9.44113 2.02136 9.56312 1.78488C9.68512 1.5484 9.89633 1.37029 10.15 1.28998C12.403 0.562876 14.8729 1.22853 16.4554 2.98931C18.0378 4.75008 18.437 7.27677 17.4744 9.43963C16.5118 11.6025 14.3674 12.9971 12 13Z",
    fill: "#FA5F5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropPin);
export default __webpack_public_path__ + "static/media/dropPin.7ce4b0df8c713b1ab20041f4d0fc79da.svg";
export { ForwardRef as ReactComponent };